import './assets/css/App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import { useState } from 'react';
import { getCookie } from 'cookies-next';
import AdminLayout from './layouts/admin';
import SignInDefault from 'views/auth/signIn/SignInDefault';
import initialTheme from './theme/theme';
import Success from 'views/PortalCiudadano/ok';
import Fail from 'views/PortalCiudadano/fail';
import TurnosRealTime from 'views/Turnos_PUB/Turnos';
import ConsultaFolioOP from 'views/ObrasPublicas/PortalCiudadano/ConsultaFolioOP';
import PortalObrasHome from 'views/PortalObras/PortalObrasHome';
import PortalPreRegistroOP from 'views/PortalObras/PortalPreRegistroOP';
import PortalTramiteDigitalOP from 'views/PortalObras/PortalTramiteDigitalOP';
import { AppThemePreferenceProvider } from 'contexts/ThemePreferenceContext';
// ── Portal Ciudadano 2026 (Deportes / IMM) ──
import Portal2026Home from 'views/Portal2026/Portal2026Home';
import ConvocatoriasDeportesPublico from 'views/Portal2026/ConvocatoriasDeportesPublico';
import InscripcionDeportesPublico from 'views/Portal2026/InscripcionDeportesPublico';
import SolicitudAuxilioIMMPublico from 'views/Portal2026/SolicitudAuxilioIMMPublico';
import ValidarConstanciaIMMPublico from 'views/Portal2026/ValidarConstanciaIMMPublico';
import TalleresIMMPublico from 'views/Portal2026/TalleresIMMPublico';

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const token = getCookie('sesion_t');
  if (!token) {
    return <Navigate to="/auth/signin" replace />;
  }
  return children;
};

export default function Main() {
  const [currentTheme, setCurrentTheme] = useState(initialTheme);

  return (
    <ChakraProvider theme={currentTheme}>
      <AppThemePreferenceProvider>
        <Routes>
          <Route
            path="admin/*"
            element={
              <ProtectedRoute>
                <AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />
              </ProtectedRoute>
            }
          />
          <Route path="/auth/signin" element={<SignInDefault />} />
          <Route path="turnos" element={<TurnosRealTime />} />
          <Route path="success" element={<Success />} />
          <Route path="fail" element={<Fail />} />
          <Route path="portal/obras" element={<PortalObrasHome />} />
          <Route path="portal/obras/consulta" element={<ConsultaFolioOP />} />
          <Route path="portal/obras/pre-registro" element={<PortalPreRegistroOP />} />
          <Route path="portal/obras/tramite-digital" element={<PortalTramiteDigitalOP />} />
          {/* ── Portal Ciudadano 2026 (Deportes / IMM) ── */}
          <Route path="portal/2026" element={<Portal2026Home />} />
          <Route path="portal/deportes/convocatorias" element={<ConvocatoriasDeportesPublico />} />
          <Route path="portal/deportes/inscripcion" element={<InscripcionDeportesPublico />} />
          <Route path="portal/imm/solicitud" element={<SolicitudAuxilioIMMPublico />} />
          <Route path="portal/imm/validar" element={<ValidarConstanciaIMMPublico />} />
          <Route path="portal/imm/talleres" element={<TalleresIMMPublico />} />
          <Route path="/" element={<Navigate to="/admin/index" replace />} />
        </Routes>
      </AppThemePreferenceProvider>
    </ChakraProvider>
  );
}
